import { Typography } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface PasscodeBoxesProps {
    passcode: string;
    maxLength: number;
}

export const PasscodeBoxes = React.memo<PasscodeBoxesProps>(function PasscodeBoxes({
    passcode,
    maxLength,
}) {
    const colors = useUIColors();

    const boxes = Array.from({ length: maxLength }, (_, i) => {
        const filled = i < passcode.length;
        return (
            <View
                key={i}
                style={[
                    styles.box,
                    {
                        backgroundColor: '#f2f2f2',
                        borderColor: '#b3b3b3',
                    },
                ]}
            >
                {filled ? (
                    <Typography variant="body" color="fontPrimary" style={styles.star}>
                        *
                    </Typography>
                ) : null}
            </View>
        );
    });

    return <View style={styles.container}>{boxes}</View>;
});

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 24,
        paddingHorizontal: 16,
    },
    box: {
        width: 58,
        height: 58,
        borderRadius: 16,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    star: {
        fontWeight: '600',
        fontSize: 16,
    },
});

export default PasscodeBoxes;


